<mat-form-field>
  <input matInput placeholder="File Name" [ngModel]="resource ? resource.name : 'Please select a file'" disabled="disabled" [ngModelOptions]="{standalone: true}" autocomplete="off" />
  <span matSuffix>
    <button class="btn btn-primary" type="button" (click)="fileInput.click()" [disabled]="disabled">
      <i class="fas fa-upload mr-1"></i><span>Choose file</span>
      <input #fileInput type="file" #file (change)="fileSelected($event)" style="display:none;" />
    </button>
  </span>
  <mat-hint>{{hint}}</mat-hint>
</mat-form-field>
